import React, { Component } from 'react';
import { Steps, Step } from '../../components/Steps';
import SetupModal from '../../components/SetupModal';
import Wrapper from './style';
import { getExchange, notificationExchange } from '../../common/fetch';

import General from './General';
import Branding from './Branding';
// import TradingInterface from './TradingInterface';
import Assets from './Assets';
import Pairs from './Pairs';
import Hosting from './Hosting';

class CreateExchange extends Component {
	state = {
		isLoaded: false,
		cur: 0,
		finish: 0,
		isOpen: false,
		setup_Success:false
	};

	componentDidMount() {
		const { location, exchange, setupActions } = this.props;
		if (location.pathname.indexOf('setup') >= 0) {
			const exchangeId = parseInt(location.search.split('=')[1], 10);
			const setupExchange = exchange.filter(
				(item) => item.id === exchangeId
			);
			if (exchange.length !== 0 && setupExchange.length && setupExchange[0].hasOwnProperty('info')) {
				setupActions.updateBiz({
					...setupExchange[0].info.biz,
					id: setupExchange[0].id,
					is_completed: setupExchange[0].info.is_completed,
				});
				setupActions.updateTech({
					...setupExchange[0].info.tech,
					id: setupExchange[0].id,
					is_completed: setupExchange[0].info.is_completed,
					type: setupExchange[0].type
				});
				const cur = setupExchange[0].is_completed ? 5 : 0;
				const finish = setupExchange[0].is_completed ? 5 : 0;
				this.setState({
					cur,
					finish,
					isLoaded: true,
				});
			} else if (exchange.length) {
				setupActions.updateBiz({
					...exchange[0].info.biz,
					id: exchange[0].id,
					is_completed: exchange[0].info.is_completed,
				});
				setupActions.updateTech({
					...exchange[0].info.tech,
					id: exchange[0].id,
					is_completed: exchange[0].info.is_completed,
					type: exchange[0].type
				});
				this.setState({ isLoaded: true });
			}
		} else if (location.pathname.indexOf('new') >= 0) {
			setupActions.readData();
			this.setState({ isLoaded: true });
		}
		if (this.props.exchange.length) {
			if (this.props.exchange[0].is_completed) {
				this.props.history.push('/dashboard');
			} else {
				this.props.history.push(`/exchange/setup?id=${this.props.exchange[0].id}`);
				this.setState({ cur:1});
			}
		}
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.exchange) !== JSON.stringify(this.props.exchange)
			&& this.props.exchange.length
		) {
			if (this.props.exchange[0].is_completed) {
				this.props.history.push('/dashboard');
			} else {
				this.props.history.push(`/exchange/setup?id=${this.props.exchange[0].id}`);
				if (this.state.cur === 0) {
					this.setState({ cur: 1 });
				}
			}
		}
	}

	getExchange = async () => {
		try {
			const res = await getExchange();
			const exchange = res.data.data.sort((a, b) => {
				const ad = new Date(a.updated_at);
				const bd = new Date(a.updated_at);
				if (Math.floor(ad - bd) >= 0) {
					return a - b;
				} else {
					return b - a;
				}
			});

			this.props.actions.readData(exchange);
		} catch (error) {
			console.error(error);
		}
	};

	handleClick = (cur) => {
		if (cur > this.state.finish) {
			return;
		}
		this.setState({ cur }, () => {
			if (cur === 0) {
				this.getExchange();
			}
		});
	};

	hideModal = () => {
		this.setState({ isOpen: false });
	};

	handleOk = () => {
		this.setState({ isOpen: false }, async () => {
			try {
				if (this.props.tech.SERVER_TYPE === 'cloud') {
					this.props.history.push('/dashboard');
					await notificationExchange(this.props.biz.id);
				} else {
					this.props.history.push('/dashboard');
				}
				this.getExchange();
			} catch (err) {
				console.error(err);
			}
		});
	};

	setForm = (num) => {
		this.setState({
			cur: num,
			finish: num - 1,
		});
	};

	onOk = (value) => {
		this.setState({ isOpen: value });
	}

	handleSetupSuccess =(e)=>{
		this.setState({setup_Success:true})
	}
	renderForm = (cur) => {
		switch (cur) {
			case 0:
				return (
					<General
						onOk={() => {
							this.setForm(1);
						}}
					/>
				);
			case 1:
				return (
					<Branding
						onOk={() => {
							this.setForm(2);
						}}
					/>
				);
			case 2:
				return (
					<Assets
						onOk={() => {
							this.setForm(3);
						}}
					/>
				);
			case 3:
				return (
					<Pairs
						onOk={() => {
							this.getExchange();
							this.setForm(4);
						}}
						moveToStep={(step) => {
							this.setState({ cur: step });
						}}
					/>
				);
			// case 4:
			// 	return (
			// 		<TradingInterface
			// 			onOk={() => {
			// 				this.getExchange();
			// 				this.setForm(5);
			// 			}}
			// 		/>
			// 	);
			case 4:
				return (
					<Hosting
						history={this.props.history}
						getExchange={this.getExchange}
						onOk={this.handleOk}
						moveToStep={(step) => {
							this.setState({ cur: step });
						}}
						handleSetupSuccess={this.handleSetupSuccess}
						setup_Success={this.state.setup_Success}
					/>
				);
			default:
				break;
		}
	};

	render() {
		const { cur, finish, isOpen, isLoaded , setup_Success } = this.state;
		const { tech } = this.props;
		if (!isLoaded) return null;
		return (
			<Wrapper>
				<div className={!setup_Success ? "main-panel" : "main-panel main-panel-1" }>
					{!setup_Success?<><h2 className="title">Exchange General Setup</h2>
					<p className="sec-title">
						Start your exchange business by following the 5 steps below
					</p></>
					:null}
					<Steps width={setup_Success? '70%': ''}>
						<Step
							step={1}
							content="General"
							status={cur === 0 ? 1 : finish >= 0 ? 2 : 0}
							setup_Success={setup_Success}
							// onClick={() => {
							// 	this.handleClick(0);
							// }}
						/>
						<Step
							step={2}
							content="Business"
							status={cur === 1 ? 1 : finish >= 1 ? 2 : 0}
							onClick={() => {
								this.handleClick(1);
							}}
							setup_Success={setup_Success}
						/>
						<Step
							step={3}
							content="Asset Setup"
							status={cur === 2 ? 1 : finish >= 2 ? 2 : 0}
							onClick={() => {
								this.handleClick(2);
							}}
							setup_Success={setup_Success}
						/>
						<Step
							step={4}
							content="Trading Pair"
							status={cur === 3 ? 1 : finish >= 3 ? 2 : 0}
							onClick={() => {
								this.handleClick(3);
								this.setState({ setup_Success:false })
							}}
							setup_Success={setup_Success}
						/>
						{/* <Step
							step={5}
							content="Trading Interface"
							status={cur === 4 ? 1 : finish >= 4 ? 2 : 0}
							onClick={() => {
								this.handleClick(4);
							}}
						/> */}
						<Step
							step={5}
							content="Plan & Hosting"
							status={(cur === 4 && !setup_Success) ? 1 : setup_Success ? 2 : 0}
							onClick={() => {
								this.handleClick(5);
							}}
							setup_Success={setup_Success}
						/>
					</Steps>
				</div>
				<div className="form-container">{this.renderForm(cur)}</div>
				{isOpen && (
					<SetupModal
						isOpen={isOpen}
						onCancel={this.hideModal}
						onOk={this.handleOk}
						desc={tech.SERVER_TYPE}
					/>
				)}
			</Wrapper>
		);
	}
}

export default CreateExchange;
